import axios from "axios";
import { dnApiConfig } from "../config/api.config";

export const warmupLambda = async (): Promise<boolean> => {
  const warmupUrl = dnApiConfig.baseUrl + "/warmup";
  const headers = {
    "Content-Type": "application/json",
    "x-api-key": dnApiConfig.apiKey,
  };
  try {
    const res = await axios.get(warmupUrl, {
      timeout: 10000,
      headers,
    });
    console.log("warmup response", res);
    return res.status === 200;
  } catch (err) {
    console.error("Lambda warmup failed:", err);
    return false;
  }
};
export const warmupUserListLambda = async (): Promise<boolean> => {
  const warmupUrl = dnApiConfig.baseUrl + "/warmup-users-list";
  const headers = {
    "Content-Type": "application/json",
    "x-api-key": dnApiConfig.apiKey,
  };
  try {
    const res = await axios.get(warmupUrl, {
      timeout: 10000,
      headers,
    });
    console.log("warmup response", res);
    return res.status === 200;
  } catch (err) {
    console.error("Lambda warmup failed:", err);
    return false;
  }
};
